module.exports = __webpack_public_path__ + "img/chart2_image.ad3dc4d4.png";